import { render, staticRenderFns } from "./DeviceHumanInfrared.vue?vue&type=template&id=24c0dfa8&scoped=true&"
import script from "./DeviceHumanInfrared.vue?vue&type=script&lang=js&"
export * from "./DeviceHumanInfrared.vue?vue&type=script&lang=js&"
import style0 from "./DeviceHumanInfrared.vue?vue&type=style&index=0&id=24c0dfa8&lang=scss&scoped=true&"
import style1 from "./DeviceHumanInfrared.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c0dfa8",
  null
  
)

export default component.exports